module.exports = __webpack_public_path__ + "static/media/empty-menu.a60aa106.svg";